export default "__VITE_ASSET__pZO3YnYS__"